import { Chip } from "@mui/material";
import IsoIcon from "@mui/icons-material/Iso";

type HandycapChipProps = {
  handycap: number;
};

export const HandycapChip = ({ handycap }: HandycapChipProps) => {
  return (
    <Chip
      icon={<IsoIcon />}
      sx={{ fontSize: "1.2rem" }}
      label={`${handycap > 0 ? "+" : ""}${handycap}`}
    />
  );
};
